"use strict";

var _taggedTemplateLiteral = require("/root/website/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _defineProperty = require("/root/website/node_modules/@babel/runtime/helpers/defineProperty");

var _templateObject;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.gridConfig = void 0;

var _stylitas = require("@creditas/stylitas");

var defaultConfig = {
  gridColumns: {
    xs: 'repeat(8, 1fr)',
    md: 'repeat(12, 1fr)'
  },
  gridColumnGap: {
    xs: '8px',
    md: '24px'
  },
  gridPadding: ['0 20px', '0 20px', '0 24px', '0'],
  gridRows: {
    xs: null,
    md: null
  },
  gridAreas: {
    xs: null,
    md: null
  },
  gridRowGap: {
    xs: null,
    md: null
  }
};

var gridConfig = function gridConfig(_ref) {
  var options = _ref.options;

  var config = _objectSpread(_objectSpread({}, defaultConfig), options);

  var gridAreas = config.gridAreas,
      gridColumns = config.gridColumns,
      gridRows = config.gridRows,
      gridJustifyItems = config.gridJustifyItems,
      gridJustifyContent = config.gridJustifyContent,
      gridAlignItems = config.gridAlignItems,
      gridAlignContent = config.gridAlignContent,
      gridRowGap = config.gridRowGap,
      gridColumnGap = config.gridColumnGap,
      gridPadding = config.gridPadding;
  return (0, _stylitas.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    display: grid;\n    justify-items: ", ";\n    align-items: ", ";\n    align-content: ", ";\n    justify-content: ", ";\n\n    ", "\n  "])), gridJustifyItems, gridAlignItems, gridAlignContent, gridJustifyContent, (0, _stylitas.mq)({
    gridTemplateAreas: (0, _stylitas.mediaValue)(gridAreas.xs, gridAreas.md),
    gridTemplateColumns: (0, _stylitas.mediaValue)(gridColumns.xs, gridColumns.md),
    gridTemplateRows: (0, _stylitas.mediaValue)(gridRows.xs, gridRows.md),
    gridRowGap: (0, _stylitas.mediaValue)(gridRowGap.xs, gridRowGap.md),
    gridColumnGap: (0, _stylitas.mediaValue)(gridColumnGap.xs, gridColumnGap.md),
    padding: gridPadding
  }));
};

exports.gridConfig = gridConfig;